import type { TelegramChat } from '@/types/api';
import { leadTitle, shownEmail } from '@/utils/format';

/** Whether a chat waits for a team member, is linked, or lost the bot. */
export const ChatState = ({ chat }: { chat: TelegramChat }) => {
  if (chat.left_at) return <span className="text-xs text-fg-faint">Bot left the group</span>;
  if (chat.lead_id) return <span className="text-xs text-fg-muted [overflow-wrap:anywhere]">Linked to {shownEmail(chat.lead_email) || leadTitle(chat.lead_name, chat.lead_email)}</span>;
  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-fg">
      <svg viewBox="0 0 16 16" className="h-3.5 w-3.5 text-status-warning" fill="currentColor" aria-hidden>
        <path d="M8 1.5 15 14H1z" />
      </svg>
      {chat.claimed_email ? 'Confirm the client' : 'Waiting for the client’s email'}
    </span>
  );
};
